import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as appActionCreators from '../actions/app';
import * as timerActionCreators from '../actions/timer';

import Sidebar from './sidebar.jsx'
import Mainloading from './mainloading.jsx'
import Socketconnector from './socketconnector.jsx'

class App extends Component {

  componentDidMount = () => {
    const appData = JSON.parse(localStorage.getItem('appData'));
    if(appData){
      this.props.fetchMainData();
    }
  }
  
  render() {
    return (
      <div className="container-fluid">
        { this.props.app.main_loading ? <Mainloading /> : null}
        <div className = "row">
          <div className="side-bar">
            <Sidebar workspace={this.props.app.work_space} socketStatus={this.props.app.socket_connect}/>
          </div>
          <div className="main-div">
            {this.props.children}
          </div>
        </div>
        <Socketconnector {...this.props} />
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    app: state.app
  }
}

const actionCreators = Object.assign({}, appActionCreators, timerActionCreators)

function mapDispachToProps(dispatch) {
  return bindActionCreators(actionCreators, dispatch);
}

export default connect(mapStateToProps, mapDispachToProps)(App);
